import ActiveButton from "../../../../CommonElements/Button/ActiveButton";
import PengaturanListLayout from "../../../../Layout/Components/PengaturanListLayout";
import useAxios from "../../../../Utils/useAxios";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import FooterModal from "./FooterModal";
import toggleFooter from "../services/toggleFooter";

const FooterList = ({ items, resetState, pending }) => {
  const axiosInstance = useAxios();

  const handleToggleActivate = async (id) => {
    try {
      await toggleFooter(axiosInstance, id);
      resetState();
    } catch (error) {
      console.error('Failed to toggle footer:', error);
    }
  };

  const columns = [
    {
      name: <DataTableTitle text="ID" />,
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: <DataTableTitle text="Content" />,
      selector: (row) => row.content,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text="Created At" />,
      selector: (row) => new Date(row.created_at).toLocaleDateString(),
      sortable: true,
    },
    {
      name: <DataTableTitle text="Operations" />,
      width: "15%",
      cell: (row) => (
        <div>
          <FooterModal create={false} data={row} resetState={resetState} />
          &nbsp;&nbsp;
          <ActiveButton
            isActive={row.is_active}
            toggle={() => handleToggleActivate(row.id)}
          />
        </div>
      ),
    },
  ];

  return (
    <PengaturanListLayout
      items={items}
      itemColumns={columns}
      searchCategories={["id", "content"]}
      pending={pending}
    />
  );
};

export default FooterList;